import { IAuthForgottenPass } from "@api/auth.int";
import { Box, Button, FormControl, FormLabel, Input, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, useBoolean } from "@chakra-ui/react";
import { useDeepAuth, useVVApi } from "components/api";
import { DeepErrorBox } from "components/misc";
import { RemoteButton } from "components/RemoteButton";
import { VizvButtonPrimary, VizvCardHeader } from "components/vizvComponents";
import { useState } from "react";
import { getGReCaptcha, GReCaptchaBox } from "./DeepAuth";


export function UserForgottenPass({ onSignIn }: { onSignIn: (message: string) => void; }) {

    const api = useVVApi();
    const auth = useDeepAuth();
    const isResendReg = auth.signedUser && auth.signedUser.status === 'T';

    const onSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        const target = e.target as typeof e.target & {
            email: { value: string };
        };
        const email = target.email.value;
        setIsLoading.on();
        setError('');
        try {
            const grecaptchaToken = await getGReCaptcha();
            const resp = await api.fetch<IAuthForgottenPass>({
                url: '/auth/forgotten-pass',
                method: 'POST',
                payload: {
                    email, grecaptchaToken,
                }
            });
            if (isResendReg)
                onSignIn(`Email-t küldtünk a ${email} címre. A levélben található linkre kattintva megerősítheted az email-címed.`);
            else
                onSignIn(`Email-t küldtünk a ${email} címre. A levélben található linkre kattintva megváltoztathatod a jelszavad.`);
        } catch (ex) {
            setError('' + ex);
        } finally {
            setIsLoading.off();
        }
    }

    const [isLoading, setIsLoading] = useBoolean();
    const [error, setError] = useState('');

    return <form onSubmit={onSubmit}>

        <ModalContent bg='cardbg.popup'>
            <ModalHeader>
                <ModalCloseButton />
                <VizvCardHeader fontSize='xl' boxShadow='lg' mt={1} isModal>{isResendReg ? 'Megerősítés' : 'Elfelejtett jelszó'}</VizvCardHeader>
            </ModalHeader>
            <ModalBody>
                <DeepErrorBox error={error} isLoading={isLoading} />
                <Box mb={3}>
                    Ha elfelejtetted a jelszavad, add meg az email címed és küldünk egy linket, amivel megváltoztathatod azt.
                </Box>
                <fieldset disabled={isLoading}>
                    <FormControl>
                        <FormLabel>Email cím</FormLabel>
                        <Input type='email' autoComplete="email" name='email' defaultValue={auth.userAny?.email || ''} />
                    </FormControl>
                </fieldset>
                <GReCaptchaBox />
            </ModalBody>

            <ModalFooter justifyContent='space-between'>
                <Button onClick={() => onSignIn('')} variant='solid' colorScheme='blackAlpha' color='white' fontWeight='400'>Bejelentkezés</Button>
                <VizvButtonPrimary type='submit' isLoading={isLoading} protLev='any' >
                    Email-t kérek
                </VizvButtonPrimary>
            </ModalFooter>
        </ModalContent>
    </form>


}